import React, { Fragment } from "react";
import useQueryParams from "src/hooks/useQueryParams";
import BrandTable from "../brands";
import ManufacturerTable from "../manufacturer";
import ProductList from "./ProductList";

export default function ProductTable() {
  const [option] = useQueryParams();

  return (
    <Fragment>
      {option?.tab === "product" && <ProductList />}
      {option?.tab === "brands" && <BrandTable />}
      {option?.tab === "manufacturer" && <ManufacturerTable />}
      {!["product", "brands", "manufacturer"]?.includes(option?.tab) && <ProductList />}
    </Fragment>
  );
}
